import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUser } from '../../services';
import { useAppContext } from '../../context/AppContext';

export const JoinTeamForm = ({ onError, onBack }) => {
  const { base_url, setToken } = useAppContext();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailRegex.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    if (!formData.password || formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';
    if (!formData.fname.trim()) newErrors.fname = 'First name is required';
    if (!formData.lname.trim()) newErrors.lname = 'Last name is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await createUser(formData, setToken, base_url);
      if (response) {
        navigate('/?first_time=true');
      } else {
        onError('Failed to create user');
      }
    } catch (error) {
      onError(error.message);
    }
  };

  return (
    <div>
      <div className="step-header">
        <h2>Join Your Team</h2>
        <p>Create your account to join your team on Slipstream.</p>
      </div>

      <form onSubmit={handleSubmit} className="form-section">
        <div className="form-row">
          <div className="form-group">
            <label className="form-label" htmlFor="fname">First name</label>
            <input type="text" id="fname" name="fname" className="form-input" value={formData.fname} onChange={handleChange} required />
            {errors.fname && <span className="form-error">{errors.fname}</span>}
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="lname">Last name</label>
            <input type="text" id="lname" name="lname" className="form-input" value={formData.lname} onChange={handleChange} required />
            {errors.lname && <span className="form-error">{errors.lname}</span>}
          </div>
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="email">Email</label>
          <input type="email" id="email" name="email" className="form-input" value={formData.email} onChange={handleChange} required />
          {errors.email && <span className="form-error">{errors.email}</span>}
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="password">Password</label>
          <input type="password" id="password" name="password" className="form-input" value={formData.password} onChange={handleChange} required />
          {errors.password && <span className="form-error">{errors.password}</span>}
        </div>
        <div className="step-nav">
          <button type="button" className="btn btn-secondary" onClick={onBack}>← Back</button>
          <div className="step-nav-right">
            <button type="submit" className="btn btn-primary">Create Account</button>
          </div>
        </div>
      </form>
    </div>
  );
};
